/** @format */
import { useTranslation } from 'next-i18next';
import React, { Fragment, FunctionComponent, useContext } from 'react';

import { MarketContext } from '@toucan/client/global/market';
import { WrappedLink } from '@toucan/client/global/nextjs';
import { LinkVariant } from '@toucan/client/shared/components/link';

import { DEFAULT_TEST_ID } from './constants';
import { ProductWrappedLinkProps } from './types';

export const ProductWrappedLink: FunctionComponent<ProductWrappedLinkProps> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    children,
    isCurrentProduct,
    sku,
    urlSegment,
    ...otherProps
}) => {
    const { t } = useTranslation();
    const { activeMarket } = useContext(MarketContext);

    if (isCurrentProduct) {
        return <Fragment>{children}</Fragment>;
    }

    const productSlug = t('product', { ns: 'urls' });
    const internalLink = `/product?slug=${urlSegment}&sku=${sku}`;
    const externalLink = `/${activeMarket.slug}/${productSlug}/${urlSegment}/sku-${sku}`;

    return (
        <WrappedLink
            data-testid={dataTestId}
            variant={LinkVariant.CUSTOM}
            href={internalLink}
            as={externalLink}
            passHref
            hasOutlineOnFocus
            target="_blank"
            {...otherProps}
        >
            {children}
        </WrappedLink>
    );
};
